export const capitalizeFirstLetter = (text: string) =>
  text.charAt(0)?.toUpperCase() + text?.slice(1);

export const getFirstLetter = (text: string) => text?.charAt(0);
